import { useState } from "react";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { refreshRed, useRedEstado } from "@/lib/red";

export const AVISO_RED = "Tus contactos se muestran a tu red solo por categoría y ciudad. Nadie ve su nombre ni teléfono hasta que tú lo decides.";

export const PrivacyGate = ({ children }) => {
  const [estado] = useRedEstado();
  const [busy, setBusy] = useState(false);
  if (!estado) return <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin c-muted" /></div>;
  if (estado.acepto_aviso) return children;
  const accept = async () => {
    setBusy(true);
    try { await api.post("/red/aviso/aceptar"); await refreshRed(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="privacy-notice" className="c-card p-6 space-y-5 border-[#bc9538]/50 animate-in fade-in slide-in-from-bottom-2">
      <ShieldCheck className="w-10 h-10 c-accent" />
      <div className="space-y-2">
        <p className="font-mono text-[10px] tracking-[0.2em] uppercase c-muted">Aviso de privacidad · Red CONECTA</p>
        <p data-testid="privacy-notice-text" className="text-lg font-semibold leading-snug">{AVISO_RED}</p>
      </div>
      <button data-testid="privacy-notice-accept-btn" disabled={busy} onClick={accept} className="c-btn-primary w-full py-3 flex items-center justify-center gap-2">
        {busy && <Loader2 className="w-4 h-4 animate-spin" />} Entendido
      </button>
    </div>
  );
};
